import { axiosInstance as axios } from "services";

export const fetchMasterPlan = async () => {
  const { data } = await axios.get("/admin/baseplanuser");
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch master plan");
  return data;
};

